import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild, ViewChild } from '@angular/core';

import { IPaginationResponseResolver, ISoftDeletablePaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, IDialogConfig, ITableConfig, PaginatedTableComponent } from '../../../ui';
import { ISoftDeletableEntity } from '../../../primitives';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-soft-deletable-entities',
  standalone: true,
  providers: [],
  imports: [PaginatedTableComponent, CommonModule, TranslateModule],
  templateUrl: './soft-deletable-entities.component.html',
  styleUrls: ['./soft-deletable-entities.component.scss']
})
export class SoftDeletableEntitiesComponent<
  TEntity extends ISoftDeletableEntity,
  TPaginationParameters extends ISoftDeletablePaginationParameters
> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();

  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [
      { name: 'autoIncrementalId', displayName: 'Id' },
      ...(this.tableConfig()?.fields ?? []),
      { name: 'isActive', displayName: 'GENERAL.STATUS' }
    ],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
